import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-number-box',
    templateUrl: './number-box.html',
    styleUrls: ['./number-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumberBoxDialog {
    title: string;
    number: number | null;

    constructor(
        public dialogRef: MatDialogRef<NumberBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { title: string; number?: number }) {
        this.title = data.title;
        this.number = data.number;
    }

    get IsValidNumber(): boolean {
        return this.number !== null && Number.isInteger(this.number) && this.number >= 0;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        if (this.IsValidNumber) {
            this.dialogRef.close(this.number);
        }
    }
}